import React from 'react';
import Confetti from 'react-confetti';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { TOOLBAR_HEIGHT } from '../../../utils/style-const';

const ThankYouRegistrationPage = ({ location }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Container
            maxWidth="sm"
            sx={{ float: 'right', marginTop: theme.spacing(4) }}
        >
            <Confetti
                tweenDuration={20000}
                recycle={false}
                height={window.innerHeight - TOOLBAR_HEIGHT}
            />
            <Typography variant='h3' gutterBottom>
                Dziękujemy za wybranie Diety Niemowlaka!
            </Typography>

                <Typography>
               Wysłaliśmy Ci e-mail z linkiem aktywacyjnym. Sprawdź swoją skrzynkę odbiorczą i kliknij link, aby dokończyć rejestrację. Jeśli nie otrzymasz od nas e-maila w ciągu kilku minut,
               sprawdź folder ze spamem.
                </Typography>

            <Typography variant="body2" sx={{ marginTop: theme.spacing(4) }}>
                W razie pytań pisz do nas na adres mailowy: <a href="mailto:kontakt@dietaniemowlaka.pl">kontakt@dietaniemowlaka.pl</a>
            </Typography>
        </Container>
    );
};

export default ThankYouRegistrationPage